import { combineReducers } from 'redux';

import { leadsBenchmark } from 'app/dealer/dashboard/Dashboard/LeadsBenchmark/redux/reducer';
import { defaultState as leadsBenchmarkDefaultState } from 'app/dealer/dashboard/Dashboard/LeadsBenchmark/redux/reducer.defaultState';
import { listingsBenchmark } from 'app/dealer/dashboard/Dashboard/ListingsBenchmark/redux/reducer';
import { defaultState as listingsBenchmarkDefaultState } from 'app/dealer/dashboard/Dashboard/ListingsBenchmark/redux/reducer.defaultState';

import { defaultState as levelDefaultState } from './level/reducer.defaultState';
import { level } from './level/reducer';
import { dateRange } from './dateRange/reducer';
import { defaultState as dateRangeDefaultState } from './dateRange/reducer.defaultState';

export const dealersInsightsDefaultState = () => ({
  dateRange: dateRangeDefaultState(),
  level: levelDefaultState(),
  leadsBenchmark: leadsBenchmarkDefaultState(),
  listingsBenchmark: listingsBenchmarkDefaultState(),
});

export const dealersInsights = combineReducers({
  dateRange,
  level,
  leadsBenchmark,
  listingsBenchmark,
});
